import * as yup from 'yup'

export const getAddressNumberValidation = () => yup.string().max(15).required()
